import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { combineLatest, distinctUntilChanged, Observable, Subject, takeUntil } from 'rxjs';
import { IGlobalSettings } from 'src/app/core/domain/settings.model';
import { IPartnerBranding } from 'src/app/core/domain/partner-branding.model';
import { getGlobalSettings } from 'src/app/core/state/global';
import { getPartnerBranding } from 'src/app/core/state/partner-branding';

@Component({
  selector: 'app-logo-renderer',
  templateUrl: './logo-renderer.component.html',
  styleUrls: ['./logo-renderer.component.scss']
})
export class LogoRendererComponent implements OnInit, OnDestroy {
  globalSettings: IGlobalSettings;
  public globalSettings$: Observable<IGlobalSettings>;
  private destroyed$: Subject<void> = new Subject();
  logoUrl= 'assets/images/logos/logo-2.svg'
  headerLogoUrl= 'assets/images/logos/logo-2.svg'
  /**
   * Tracked separately from `logoUrl` (which already folds the spoke's own
   * logo over the hub's) so `coBranded` can tell whether there actually IS a
   * spoke logo to show alongside the hub's -- `null` on the hub's own
   * hostname, or on a spoke that hasn't set one.
   */
  hubLogoUrl = 'assets/images/logos/logo-2.svg'
  spokeLogoUrl: string | null = null;
  spokeBrandName: string | null = null;
  @Input() class = '';
  @Input() headerLogo = false;
  /**
   * Opt-in dual lockup (hub logo + spoke logo + spoke name side by side),
   * matching sc-saas-admin's own partner-session navbar
   * (themes/default/html/elements/partners/header.php) -- default false
   * keeps every existing single-logo consumer (sidebars, etc.) unchanged.
   * Falls back to the single hub logo automatically when there's no spoke
   * logo to pair it with (i.e. visiting the hub's own hostname).
   */
  @Input() coBranded = false;
  constructor(
    private readonly store: Store,
  ) { }

  ngOnInit(): void {
    this.globalSettings$ = this.store.pipe(select(getGlobalSettings));
    combineLatest([
      this.globalSettings$,
      this.store.pipe(select(getPartnerBranding)),
    ]).pipe(distinctUntilChanged(), takeUntil(this.destroyed$)).subscribe(([res, partnerBranding]: [IGlobalSettings, IPartnerBranding]) => {
      if (res) {
        this.globalSettings = res;
        /* Spoke's own logo/headerLogo wins whenever set -- falls back to the
           hub's tenant-wide branding for anything the spoke hasn't
           configured (SAN-386, per the governing feature's fallback rule). */
        this.logoUrl = partnerBranding?.logo || res?.branding?.logo || 'assets/images/logos/logo-2.svg'
        this.headerLogoUrl = partnerBranding?.headerLogo || res?.branding?.headerLogo || 'assets/images/logos/logo-2.svg'
        this.hubLogoUrl = res?.branding?.logo || 'assets/images/logos/logo-2.svg'
        this.spokeLogoUrl = partnerBranding?.logo || null;
        this.spokeBrandName = partnerBranding?.brandName || null;
      }
    })
  }


  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
